import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';
import { includesManufactureType } from 'shared/utils/filters/includesManufactureType';
import { isSingleOfficeType } from 'shared/utils/filters/isSingleOfficeType';

import { IFiltersService } from '../../IFiltersService';

import { AbstractAdvancedFiltersService } from './AbstractAdvancedFiltersService';

/**
 * @description Сервис для категории "Производство". Не имеет значение аренда или продажа
 */
export class AnyManufactureAdvancedFiltersService
  extends AbstractAdvancedFiltersService
  implements IFiltersService<EAdvancedFilterType>
{
  public isAvailable(): boolean {
    return [isSingleOfficeType, includesManufactureType].every(fn => fn(this.filters));
  }

  public getFields(): EAdvancedFilterType[] {
    return super
      .getFields()
      .concat(
        EAdvancedFilterType.specialtyTypes,
        EAdvancedFilterType.floor,
        EAdvancedFilterType.floorTypes,
        EAdvancedFilterType.conditionType,
        EAdvancedFilterType.buildingLiftTypesType,
        EAdvancedFilterType.buildingCranageTypesType,
        EAdvancedFilterType.buildingGatesType,
        EAdvancedFilterType.buildingHeatingType,
        EAdvancedFilterType.contract,
        EAdvancedFilterType.houseYear,
        EAdvancedFilterType.parkingType,
        EAdvancedFilterType.infrastructure,
        EAdvancedFilterType.commissionType,
        EAdvancedFilterType.withoutAgentCall,
        EAdvancedFilterType.buildingType,
        EAdvancedFilterType.electronicTrading,
      );
  }
}
